module.exports = __webpack_public_path__ + "lpg-masaze_1_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/ostatni/lpg-masaze_1_before.jpg
// module id = 1048
// module chunks = 0